/**
 * 鉴权相关 API
 * 对齐后端 app/routers/auth.py
 */
import { apiPost } from './http';
import type { StoredUser } from '@/auth/storage';

export interface LoginRequest {
  account: string;
  password: string;
  accountType: 'phone' | 'studentId' | 'employeeId';
}

export interface LoginResponse {
  user: StoredUser;
  tokens: {
    accessToken: string;
    refreshToken: string;
    tokenType: string;
    expiresIn: number;
  };
  mustChangePassword: boolean;
}

export function login(body: LoginRequest) {
  return apiPost<LoginResponse>('/auth/login', body);
}

export interface RegisterRequest {
  phone: string;
  password: string;
  name: string;
}

/** 社会人士自助注册：注册即登录，返回结构同 login */
export function register(body: RegisterRequest) {
  return apiPost<LoginResponse>('/auth/register', body);
}

export function logout() {
  return apiPost<{ ok: boolean }>('/auth/logout');
}

export interface ChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
}

export function changePassword(body: ChangePasswordRequest) {
  return apiPost<{ ok: boolean }>('/auth/change-password', body);
}

export function getMe() {
  return apiPost<{ user: StoredUser }>('/auth/me');
}
